import { styled, media } from '@creditas-ui/react'

const ContainerAction = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  min-height: 92px;
  height: 15vh;

  ${media.up('7xl')} {
    min-height: 192px;
    height: 25vh;
  }
`

export { ContainerAction }
